const initialState = {
    responseCountrycodeList: { results: [] },
    responseCountrycode: null,
    responseCreate: null,
    responseUpdate: null,
    loading: false,
    error: null,
};

const reducer = (state = initialState, action) => {
    switch (action.type) {
        case "GET_COUNTRYCODES":
        case "GET_COUNTRYCODE":
            return {
                ...state,
                loading: true,
                error: null,
            };

        case "ADD_COUNTRYCODE":
        case "EDIT_COUNTRYCODE":
            return {
                ...state,
                loading: true,
                error: null,
                responseCreate: null,
                responseUpdate: null,
            };

        case "COUNTRYCODE_RESPONSE_LIST":
            return {
                ...state,
                loading: false,
                responseCountrycodeList: action.value,
                error: action.error || null,
            };

        case "COUNTRYCODE_RESPONSE":
            return {
                ...state,
                loading: false,
                responseCountrycode: action.value,
                // If it's a create/update, we also set the specific response type
                responseCreate: action.type_op === "create" ? action.value : state.responseCreate,
                responseUpdate: action.type_op === "update" ? action.value : state.responseUpdate,
                error: action.error || null,
            };

        case "COUNTRYCODE_CLEAR_STATE":
            return {
                ...initialState,
                responseCountrycodeList: state.responseCountrycodeList
            };

        default:
            return state;
    }
};

export default reducer;